<template>
  <div>
    <h1>Banners</h1>
    <p>Je kent ze inmiddels wel, bij veel websites word je gevraagd of je Cookies wilt.</p>
    <p>En vaak mag je daar geen Nee tegen zeggen...</p>
    <p>Dat is natuurlijk omdat cookies wel nodig zijn om automatisch in te loggen. Dit zijn "functionele cookies". Handig, want dan hoef je niet iedere keer opnieuw je gebruikersnaam en wachtwoord te typen.</p>
    <p>Maar tegelijkertijd wil je misschien niet dat bijv Google en Facebook precies weten waar jij geweest bent. In sommige gevallen kun je "tracking" of "advertentie" cookies uit zetten.</p>    
    <p>Kijk bijvoorbeeld eens naar het <a href="https://www.ad.nl/info" target="_blank">cookie beleid van AD.nl</a> (van het Algemeen Dagblad, een grote krant), en specifiek naar de tabellen die daar op staan. Best eng hoeveel verschillende websites weten dat je op ad.nl geweest bent...</p>
    <p>Het delen van die informatie tussen verschillende websites heet tracking. Tracking betekent "volgen" in het Engels. De websites volgen jou op internet.</p>

    <p>Sommige websites (zoals ad.nl) verplichten je om alle cookies te accepteren. Op de volgende pagina gaan we eens kijken wat we daar toch tegen kunnen doen.</p>

    <div class="cta-container">
      <router-link class="cta" to="/stap6">
        <img src="/images/arrow.svg" />
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  created() {}
};
</script>
